<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <!--    emf filter wrapper   -->
    <b-button
      type="is-danger is-light"
      outlined
      class="emf-custom-filter-applied"
      v-show="erroredItems"
    >
      Custom Filter Applied
    </b-button>
    <div class="new-item-submissions-errored-items-filter-wrapper">
      <b-dropdown aria-role="menu" trap-focus class="errored-items-filter">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Filter By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Errored Items">
            <b-select v-model="erroredItemsFilter">
              <option value=""></option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </b-select>
          </b-field>
          <b-field label="Submission Id">
            <b-input
              type="text"
              clsss="search-box"
              v-model="filterMySubmissionsId"
            >
            </b-input>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="menu" trap-focus class="errored-items-sort">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Sort By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Line Errors">
            <b-select v-model="lineErrors">
              <option value=""></option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        class="item-level-apply-button"
        @click="
          erroredItems = erroredItemsFilter;
          getErroredMFItems();
        "
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        class="item-level-reset-button"
        @click="
          erroredItemsFilter = '';
          erroredItems = '';
          getErroredMFItems();
        "
      >
        Reset
      </b-button>
    </div>
    <div class="pagination-wrapper">
      <div class="pagination-header">
        <b-button
          v-show="showPreviousButton"
          @click="
            pageIndex = pageIndex - 1;
            getErroredMFItems();
          "
          >Previous</b-button
        >
        <b-button
          v-show="totalResults > 0"
          @click="
            pageIndex = 1;
            getErroredMFItems();
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ minPageIndex }} to {{ maxPageIndex }} of {{ totalResults }}</span
        >
        <b-button
          v-show="totalResults > 0"
          @click="
            pageIndex = totalPages;
            getErroredMFItems();
          "
          >Last</b-button
        >
        <b-button
          v-show="showNextButton"
          @click="
            pageIndex = pageIndex + 1;
            getErroredMFItems();
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="totalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfItemsPerPage"
            @input="
              pageIndex = Math.floor(minPageIndex / numberOfItemsPerPage) + 1;
              getErroredMFItems();
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <div class="errored-items-table-wrapper" :class="erroredItemsEditAccess()">
      <table class="errored-items-table">
        <thead>
          <tr>
            <th>Line No.</th>
            <th class="select-checkbox-cell">
              <b-checkbox
                ref="selectAllChecked"
                v-model="selectAllChecked"
                type="is-info"
                size="is-large"
              ></b-checkbox>
            </th>
            <th
              v-for="headerName in erroredMainframeItemsColumns"
              :key="headerName.id"
              :title="renderTitle(headerName)"
            >
              <label>{{ headerName }}</label>
            </th>
          </tr>
        </thead>
        <tbody class="errored-items-table-body">
          <tr
            v-for="(row, index) in erroredMainFrameItemsData"
            :key="row.id"
            @click="onRowClick($event)"
            @change="
              !isLoading ? changeOnErroredItemsRow($event, index, row) : ''
            "
            v-bind="row"
          >
            <ValidationObserver>
              <td class="line-number">{{ row.lineNumber }}</td>
              <td class="select-checkbox-cell">
                <b-checkbox
                  type="is-info"
                  size="is-large"
                  v-model="checkboxGroup"
                  :native-value="row.genlQstnId"
                ></b-checkbox>
              </td>
              <td class="line-errors item-checkbox">
                {{ row.lineErrors }}
              </td>
              <td>{{ row.nbrNewItemCrKey }}</td>
              <td>
                <b-input
                  type="text"
                  :value="row.statusDesc"
                  :title="row.statusDesc"
                  disabled
                >
                </b-input>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="vcat"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'vcat',
                          row.vcat
                        )
                      "
                      oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ./\\\\-]/g, '');if (this.value.length > 25)
                        this.value = this.value.slice(0, 25);"
                      :value="row.vcat"
                      @change.native="row.vcat = $event.target.value"
                      disabled="disabled"
                    >
                    </b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="fcat"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'fcat',
                          row.fcat
                        )
                      "
                      oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');if (this.value.length > 11)
                        this.value = this.value.slice(0, 11);"
                      :value="row.fcat"
                      @change.native="row.fcat = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:EA,PR,DZ,PK,CS,NA"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                  vid="su"
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="su"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'su',
                          row.su
                        )
                      "
                      v-model="row.su"
                      :value="row.su === undefined ? (row.su = ' ') : row.su"
                    >
                      <option value=" "></option><option value="EA">Each</option
                      ><option value="PR">Pair</option
                      ><option value="DZ">Dozen</option
                      ><option value="PK">Pack</option
                      ><option value="CS">Case</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:1,2,3,4,5,6,7,8,9"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      v-model="row.prcType"
                      class="prcType"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'prcType',
                          row.prcType
                        )
                      "
                      :disabled="disableOnDisc(row)"
                      :value="
                        row.prcType === undefined
                          ? (row.prcType = ' ')
                          : row.prcType
                      "
                    >
                      <option value=" "></option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="9">9</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:A,C,S"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      v-model="row.prdCls"
                      :value="
                        row.prdCls === undefined
                          ? (row.prdCls = ' ')
                          : row.prdCls
                      "
                      class="prdCls"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'prdCls',
                          row.prdCls
                        )
                      "
                    >
                      <option value=" "></option>
                      <option value="A">A - Apparatus</option>
                      <option value="C">C - Chemicals</option>
                      <option value="S">S - Education</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:99998,99999,00000"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="msds"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'msds',
                          row.msds
                        )
                      "
                      v-model="row.msds"
                      :value="
                        row.msds === undefined ? (row.msds = ' ') : row.msds
                      "
                      disabled="disabled"
                    >
                      <option value=" "></option>
                      <option value="99998">
                        99998
                      </option>
                      <option value="99999">
                        99999
                      </option>
                      <option value="00000">
                        00000
                      </option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:03,07,NA"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="prodType"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'prodType',
                          row.prodType
                        )
                      "
                      v-model="row.prodType"
                      :value="
                        row.prodType === undefined
                          ? (row.prodType = ' ')
                          : row.prodType
                      "
                      disabled="disabled"
                      ><option value=" "></option>
                      <option value="03">03</option>
                      <option value="07">07</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  v-model="row.iceChg"
                  class="iceChg"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'iceChg',
                      row.iceChg
                    )
                  "
                  :value="
                    row.iceChg === undefined ? (row.iceChg = ' ') : row.iceChg
                  "
                >
                  <option value=" "></option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </b-select>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'oldMkt'">
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <v-select
                      :filterable="false"
                      :options="oldMktOptions"
                      class="oldMkt"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'oldMkt',
                          row.oldMkt
                        )
                      "
                      v-model="row.oldMkt"
                      @search="fetchTypeAhead"
                      @input="changeOnErroredItemsRow($event, index, row)"
                      :title="row.oldMkt"
                    >
                      <template slot="option" slot-scope="oldMktOption">
                        <div class="d-center">
                          {{ oldMktOption.label }}
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="oldMktOption"
                        title="oldMktOption"
                      >
                        <div class="selected d-center">
                          {{ oldMktOption.label }}
                        </div>
                      </template>
                      <template
                        slot="no-options"
                        slot-scope="{ search, searching }"
                      >
                        <template v-if="searching">
                          Sorry, no matching options.
                        </template>
                        <span v-else class="display-none"></span>
                      </template>
                    </v-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  class="storage"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'storage',
                      row.storage
                    )
                  "
                  v-model="row.storage"
                  :title="row.storage"
                  :value="
                    row.storage === undefined
                      ? (row.storage = ' ')
                      : row.storage
                  "
                  ><option value=" "></option>
                  <option
                    v-for="storageCode in storageCodes"
                    :value="storageCode"
                    :key="storageCode.id"
                  >
                    {{ storageCode }}
                  </option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="au"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'au', row.au)
                  "
                  :disabled="row.su === 'CS'"
                  v-model="row.au"
                  :value="row.au === undefined ? (row.au = ' ') : row.au"
                >
                  <option value=" "></option><option value="DZ">Dozen</option>
                  <option value="PK">Pack</option>
                  <option value="CS">Case</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <ValidationProvider
                  rules="required|max:30"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="desc30"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'desc30',
                          row.desc30
                        )
                      "
                      :value="row.desc30"
                      @change.native="row.desc30 = $event.target.value"
                    ></b-input>
                    <b-tooltip
                      label="Item Description 30 maximum length is 30 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.desc30 && row.desc30.length > 30"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="vn"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'vn',
                          row.vn
                        )
                      "
                      v-model="row.vn"
                      @change.native="row.vn = $event.target.value"
                      disabled="disabled"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'sbu'">
                <v-select
                  :filterable="false"
                  :options="sbuCodeOptions"
                  :selectable="
                    sbuCodeOption => sbuCodeOption.deleteFlag !== 'Y'
                  "
                  class="sbu"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'sbu', row.sbu)
                  "
                  v-model="row.sbu"
                  @search="fetchTypeAhead"
                  @input="
                    row.sbu = row.sbu ? row.sbu.sbuCodeDesc : row.sbu;
                    changeOnErroredItemsRow($event, index, row);
                  "
                  :title="row.sbu"
                >
                  <template slot="option" slot-scope="sbuCodeOption">
                    <div class="d-center">
                      {{ sbuCodeOption.sbuCodeDesc }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="sbuCodeOption"
                    title="sbuCodeOption"
                  >
                    <div class="selected d-center">
                      {{ sbuCodeOption.label }}
                    </div>
                  </template>
                  <template
                    slot="no-options"
                    slot-scope="{ search, searching }"
                  >
                    <template v-if="searching">
                      Sorry, no matching options.
                    </template>
                    <span v-else class="display-none"></span>
                  </template>
                </v-select>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'pc'">
                <ValidationProvider
                  :rules="{ required: true, isPcValid: { mcsVal: '@mcs' } }"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <v-select
                      :filterable="false"
                      :options="pcOptions"
                      class="pc"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'pc',
                          row.pc
                        )
                      "
                      v-model="row.pc"
                      @search="fetchTypeAhead"
                      @input="changeOnErroredItemsRow($event, index, row)"
                      :title="row.pc"
                    >
                      <template slot="option" slot-scope="pcOption">
                        <div class="d-center">
                          {{ pcOption.label }}
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="pcOption"
                        title="pcOption"
                      >
                        <div class="selected d-center">
                          {{ pcOption.label }}
                        </div>
                      </template>
                      <template
                        slot="no-options"
                        slot-scope="{ search, searching }"
                      >
                        <template v-if="searching">
                          Sorry, no matching options.
                        </template>
                        <span v-else class="display-none"></span>
                      </template>
                    </v-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 6)
                        this.value = this.value.slice(0, 6);"
                      class="vma text-align-right"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'vma',
                          row.vma
                        )
                      "
                      v-model="row.vma"
                      @change.native="row.vma = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:A90,A92,C75,NA"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="pbSec"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'pbSec',
                          row.pbSec
                        )
                      "
                      v-model="row.pbSec"
                      :value="
                        row.pbSec === undefined ? (row.pbSec = ' ') : row.pbSec
                      "
                    >
                      <option value=" "></option>
                      <option value="A90">A90</option>
                      <option value="A92">A92</option>
                      <option value="C75">C75</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  v-model="row.dirShip"
                  class="dirShip"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'dirShip',
                      row.dirShip
                    )
                  "
                  :value="
                    row.dirShip === undefined
                      ? (row.dirShip = ' ')
                      : row.dirShip
                  "
                >
                  <option value=" "></option>
                  <option value="D">D - Direct Ship</option>
                  <option value="E">E - Express Direct Ship</option>
                  <option value="N">N - Not Direct Ship</option>
                </b-select>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'byrCode'">
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <v-select
                      :filterable="false"
                      :options="byrCodeOptions"
                      class="byrCd"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'byrCd',
                          row.byrCd
                        )
                      "
                      v-model="row.byrCd"
                      @search="fetchTypeAhead"
                      @input="changeOnErroredItemsRow($event, index, row)"
                      :title="row.byrCd"
                    >
                      <template slot="option" slot-scope="byrCodeOption">
                        <div class="d-center">
                          {{ byrCodeOption.label }}
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="byrCodeOption"
                        title="byrCodeOption"
                      >
                        <div class="selected d-center">
                          {{ byrCodeOption.label }}
                        </div>
                      </template>
                      <template
                        slot="no-options"
                        slot-scope="{ search, searching }"
                      >
                        <template v-if="searching">
                          Sorry, no matching options.
                        </template>
                        <span v-else class="display-none"></span>
                      </template>
                    </v-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  class="prvLbl"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'prvLbl',
                      row.prvLbl
                    )
                  "
                  v-model="row.prvLbl"
                  :value="
                    row.prvLbl === undefined ? (row.prvLbl = ' ') : row.prvLbl
                  "
                  ><option value=" "> </option>
                  <option value="H">H - Fisher High List Product</option>
                  <option value="F">F - Fisherbrand Supply Item</option>
                </b-select>
              </td>
              <td>
                <b-select
                  v-model="row.ipf"
                  class="ipf"
                  :value="row.ipf === undefined ? (row.ipf = ' ') : row.ipf"
                >
                  <option value=" "></option>
                  <option value="1"
                    >1 - Product requires cold pack packaging with a $7.00
                    fee</option
                  >
                  <option value="2"
                    >2 - Product requires dry pack packaging with a $9.50
                    fee</option
                  >
                  <option value="N">Not Required</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="vlt"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'vlt', row.vlt)
                  "
                  v-model="row.vlt"
                  :value="row.vlt === undefined ? (row.vlt = ' ') : row.vlt"
                  :title="row.vlt"
                >
                  <option value=" "></option><option value="110">110</option>
                  <option value="115">115</option>
                  <option value="120">120</option>
                  <option value="220">220</option>
                  <option value="230">230</option>
                  <option value="380">380</option>
                  <option value="110/240">110/240</option>
                  <option value="120/240">120/240</option>
                  <option value="208/240">208/240</option>
                  <option value="240/380">240/380</option>
                </b-select>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'countryOrigin'">
                <v-select
                  :filterable="false"
                  :options="countryOriginOptions"
                  class="countryOrigin"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'countryOrigin',
                      row.countryOrigin
                    )
                  "
                  v-model="row.countryOrigin"
                  @search="fetchTypeAhead"
                  @input="changeOnErroredItemsRow($event, index, row)"
                  :title="row.countryOrigin"
                >
                  <template slot="option" slot-scope="countryOriginOption">
                    <div class="d-center">
                      {{ countryOriginOption.label }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="countryOriginOption"
                    title="countryOriginOption"
                  >
                    <div class="selected d-center">
                      {{ countryOriginOption.label }}
                    </div>
                  </template>
                  <template
                    slot="no-options"
                    slot-scope="{ search, searching }"
                  >
                    <template v-if="searching">
                      Sorry, no matching options.
                    </template>
                    <span v-else class="display-none"></span>
                  </template>
                </v-select>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:E,L,B,F,M,X,V,G,NA"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="lcp"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'lcp',
                          row.lcp
                        )
                      "
                      v-model="row.lcp"
                      :value="row.lcp === undefined ? (row.lcp = ' ') : row.lcp"
                      ><option value=" "></option>
                      <option value="E"
                        >E - Fisherbrand, Thermo Fisher Scientific owned</option
                      >
                      <option value="L"
                        >L - Fisherbrand, outside Supplied</option
                      >
                      <option value="B"
                        >B - Private label, outside Supplied</option
                      >
                      <option value="F"
                        >F - Private label, Thermo Fisher Scientific owned but
                        sourced</option
                      >
                      <option value="M"
                        >M - Private label, Thermo Fisher Scientific owned and
                        manufactured</option
                      >
                      <option value="X"
                        >X - Supplier branded, Thermo Fisher Scientific
                        owned</option
                      >
                      <option value="V"
                        >V - Supplier branded, outside supplied</option
                      >
                      <option value="G">G - Generic</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:10,15,20,25,30,40,45,50,55,60,65,90,95,NA"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="mcp"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'mcp',
                          row.mcp
                        )
                      "
                      v-model="row.mcp"
                      :value="row.mcp === undefined ? (row.mcp = ' ') : row.mcp"
                      ><option value=" "></option>
                      <option value="10">10 - General Distribution</option>
                      <option value="15">15 - Chemical</option>
                      <option value="20">20 - Biotech</option>
                      <option value="25">25 - Clinical</option>
                      <option value="30">30 - Safety</option>
                      <option value="40">40 - US Regions</option>
                      <option value="45">45 - FFD</option>
                      <option value="50">50 - FSD</option>
                      <option value="55">55 - FSE</option>
                      <option value="60">60 - Canada</option>
                      <option value="65">65 - International</option>
                      <option value="90">90 - Other</option>
                      <option value="95">95 - Third Party</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  :rules="{ oneOf: mcsCodes }"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                  vid="mcs"
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="mcs"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'mcs',
                          row.mcs
                        )
                      "
                      v-model="row.mcs"
                      :value="row.mcs === undefined ? (row.mcs = ' ') : row.mcs"
                      ><option value=" "></option>
                      <option
                        v-for="mcsCode in mcsCodes"
                        :disabled="mcsCode === '3P' && row.user3P === false"
                        :value="mcsCode"
                        :key="mcsCode.id"
                        >{{ mcsCode }}
                      </option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'cct'">
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <v-select
                      :filterable="false"
                      :options="cctOptions"
                      class="cct"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'cct',
                          row.cct
                        )
                      "
                      v-model="row.cct"
                      @search="fetchTypeAhead"
                      @input="changeOnErroredItemsRow($event, index, row)"
                      :title="row.cct"
                    >
                      <template slot="option" slot-scope="cctOption">
                        <div class="d-center">
                          {{ cctOption.label }}
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="cctOption"
                        title="cctOption"
                      >
                        <div class="selected d-center">
                          {{ cctOption.label }}
                        </div>
                      </template>
                      <template
                        slot="no-options"
                        slot-scope="{ search, searching }"
                      >
                        <template v-if="searching">
                          Sorry, no matching options.
                        </template>
                        <span v-else class="display-none"></span>
                      </template>
                    </v-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  class="hcPrf"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'hcPrf',
                      row.hcPrf
                    )
                  "
                  v-model="row.hcPrf"
                  :value="
                    row.hcPrf === undefined ? (row.hcPrf = ' ') : row.hcPrf
                  "
                  ><option value=" "></option>
                  <option value="S">S</option>
                  <option value="C">C</option>
                  <option value="G">G</option>
                  <option value="N">NA</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="rsPrf"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'rsPrf',
                      row.rsPrf
                    )
                  "
                  v-model="row.rsPrf"
                  :value="
                    row.rsPrf === undefined ? (row.rsPrf = ' ') : row.rsPrf
                  "
                  ><option value=" "></option>
                  <option value="S">S</option>
                  <option value="C">C</option>
                  <option value="G">G</option>
                  <option value="N">NA</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="sfPrf"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'sfPrf',
                      row.sfPrf
                    )
                  "
                  v-model="row.sfPrf"
                  :value="
                    row.sfPrf === undefined ? (row.sfPrf = ' ') : row.sfPrf
                  "
                  ><option value=" "></option>
                  <option value="S">S</option>
                  <option value="C">C</option>
                  <option value="G">G</option>
                  <option value="N">NA</option>
                </b-select>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace('.', '');"
                      class="uncondCat"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'uncondCat',
                          row.uncondCat
                        )
                      "
                      @input.native="validateUncondCat"
                      :value="row.uncondCat"
                      @change.native="row.uncondCat = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:5"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^\d]/g, '');"
                      :value="row.ctrlCode1"
                      @change.native="row.ctrlCode1 = $event.target.value"
                      class="ctrlCode ctrlCode1"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ctrlCode1',
                          row.ctrlCode1
                        )
                      "
                    ></b-input>
                    <b-tooltip
                      label="Control Code 1 maximum length is 5 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.ctrlCode1 && row.ctrlCode1.length > 5"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:5"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^\d]/g, '');"
                      :value="row.ctrlCode2"
                      @change.native="row.ctrlCode2 = $event.target.value"
                      class="ctrlCode ctrlCode2"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ctrlCode2',
                          row.ctrlCode2
                        )
                      "
                    ></b-input>
                    <b-tooltip
                      label="Control Code 2 maximum length is 5 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.ctrlCode2 && row.ctrlCode2.length > 5"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:5"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^\d]/g, '');"
                      :value="row.ctrlCode3"
                      @change.native="row.ctrlCode3 = $event.target.value"
                      class="ctrlCode ctrlCode3"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ctrlCode3',
                          row.ctrlCode3
                        )
                      "
                    ></b-input>
                    <b-tooltip
                      label="Control Code 3 maximum length is 5 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.ctrlCode3 && row.ctrlCode3.length > 5"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:5"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^\d]/g, '');"
                      :value="row.ctrlCode4"
                      @change.native="row.ctrlCode4 = $event.target.value"
                      class="ctrlCode ctrlCode4"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ctrlCode4',
                          row.ctrlCode4
                        )
                      "
                    ></b-input>
                    <b-tooltip
                      label="Control Code 4 maximum length is 5 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.ctrlCode4 && row.ctrlCode4.length > 5"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:5"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^\d]/g, '');"
                      :value="row.ctrlCode5"
                      @change.native="row.ctrlCode5 = $event.target.value"
                      class="ctrlCode ctrlCode5"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ctrlCode5',
                          row.ctrlCode5
                        )
                      "
                    ></b-input>
                    <b-tooltip
                      label="Control Code 5 maxim5um length is 5 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.ctrlCode5 && row.ctrlCode5.length > 5"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  class="haz"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'haz', row.haz)
                  "
                  v-model="row.haz"
                  :value="row.haz === undefined ? (row.haz = ' ') : row.haz"
                >
                  <option value=" "></option
                  ><option value="P">P - Hazardous with a packing charge</option
                  ><option value="H"
                    >H - Hazardous with no packing charge</option
                  >
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="suppUom"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suppUom',
                      row.suppUom
                    )
                  "
                  v-model="row.suppUom"
                  :value="
                    row.suppUom === undefined
                      ? (row.suppUom = ' ')
                      : row.suppUom
                  "
                >
                  <option value=" "></option><option value="CA">Case</option>
                  <option value="EA">Each</option>
                  <option value="PK">Pack</option>
                  <option value="PR">Pair</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <b-input
                  type="text"
                  class="manufacturerName"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'manufacturerName',
                      row.manufacturerName
                    )
                  "
                  :value="row.manufacturerName"
                  @change.native="row.manufacturerName = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  class="mcat"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'mcat',
                      row.mcat
                    )
                  "
                  oninput="if (this.value.length > 25)
                          this.value = this.value.slice(0, 25);"
                  :value="row.mcat"
                  @change.native="row.mcat = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-select
                  class="serLot"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'serLot',
                      row.serLot
                    )
                  "
                  @input="updateShlfLf(row)"
                  v-model="row.serLot"
                  :value="
                    row.serLot === undefined ? (row.serLot = ' ') : row.serLot
                  "
                >
                  <option value=" "></option><option value="S">Serial</option
                  ><option value="L">Lot</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <ValidationProvider
                  rules="max:11"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="key1"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'key1',
                          row.key1
                        )
                      "
                      :value="row.key1"
                      @change.native="row.key1 = $event.target.value"
                    ></b-input>
                    <b-tooltip
                      label="Keyword 1 maximum length is 11 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.key1 && row.key1.length > 11"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:11"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="key2"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'key2',
                          row.key2
                        )
                      "
                      :value="row.key2"
                      @change.native="row.key2 = $event.target.value"
                    ></b-input>
                    <b-tooltip
                      label="Keyword 2 maximum length is 11 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.key2 && row.key2.length > 11"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:11"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="key3"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'key3',
                          row.key3
                        )
                      "
                      :value="row.key3"
                      @change.native="row.key3 = $event.target.value"
                    ></b-input>
                    <b-tooltip
                      label="Keyword 3 maximum length is 11 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.key3 && row.key3.length > 11"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:11"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="key4"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'key4',
                          row.key4
                        )
                      "
                      :value="row.key4"
                      @change.native="row.key4 = $event.target.value"
                    ></b-input>
                    <b-tooltip
                      label="Keyword 4 maximum length is 11 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.key4 && row.key4.length > 11"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="max:11"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      class="key5"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'key5',
                          row.key5
                        )
                      "
                      :value="row.key5"
                      @change.native="row.key5 = $event.target.value"
                    ></b-input>
                    <b-tooltip
                      label="Keyword 5 maximum length is 11 characters in order to save this record"
                      type="is-danger"
                      position="is-top"
                    >
                      <b-icon
                        type="is-danger"
                        icon="alert-circle"
                        v-show="row.key5 && row.key5.length > 11"
                      >
                      </b-icon>
                    </b-tooltip>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      @input="calculateDiscount(row)"
                      oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                      class="suCost"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'suCost',
                          row.suCost
                        )
                      "
                      :value="
                        row.suCost !== undefined
                          ? addFourZeros(row.suCost)
                          : row.suCost
                      "
                      @change.native="row.suCost = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      @input="calculateDiscount(row)"
                      oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                      class="suList"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'suList',
                          row.suList
                        )
                      "
                      :value="
                        row.suList !== undefined
                          ? addTwoZeros(row.suList)
                          : row.suList
                      "
                      @change.native="row.suList = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');  if (this.value.split('.')[0].length > 5)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 5) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 5);"
                  class="suWt"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suWt',
                      row.suWt
                    )
                  "
                  :value="
                    row.suWt !== undefined ? addTwoZeros(row.suWt) : row.suWt
                  "
                  @change.native="row.suWt = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');  if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                  class="suLen"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suLen',
                      row.suLen
                    )
                  "
                  :value="
                    row.suLen !== undefined ? addTwoZeros(row.suLen) : row.suLen
                  "
                  @change.native="row.suLen = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                  class="suWid"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suWid',
                      row.suWid
                    )
                  "
                  :value="
                    row.suWid !== undefined ? addTwoZeros(row.suWid) : row.suWid
                  "
                  @change.native="row.suWid = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                  class="suHt"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suHt',
                      row.suHt
                    )
                  "
                  :value="
                    row.suHt !== undefined ? addTwoZeros(row.suHt) : row.suHt
                  "
                  @change.native="row.suHt = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 4)
                          this.value = this.value.slice(0, 4);"
                  class="mfgLeadTime"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'mfgLeadTime',
                      row.mfgLeadTime
                    )
                  "
                  :value="row.mfgLeadTime"
                  @change.native="row.mfgLeadTime = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 6)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 6) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 6);"
                  class="suppConv"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suppConv',
                      row.suppConv
                    )
                  "
                  :value="
                    row.suppConv !== undefined
                      ? addFourZeros(row.suppConv)
                      : row.suppConv
                  "
                  @change.native="row.suppConv = $event.target.value"
                ></b-input>
              </td>
              <td>
                <ValidationProvider
                  rules="required_if:au,DZ,PK,CS"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 10)
                          this.value = this.value.slice(0, 10);"
                      class="auQty"
                      :disabled="disableAuQtyIf(row.su, row.au)"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'auQty',
                          row.auQty
                        )
                      "
                      :value="row.auQty"
                      @change.native="row.auQty = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 5)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 5) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 5);"
                  class="auWt"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'auWt',
                      row.auWt
                    )
                  "
                  :disabled="
                    row.su === 'CS' ||
                      row.au === '' ||
                      row.au === ' ' ||
                      row.au === undefined
                  "
                  :value="
                    row.auWt !== undefined ? addTwoZeros(row.auWt) : row.auWt
                  "
                  @change.native="row.auWt = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                  class="auLen"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'auLen',
                      row.auLen
                    )
                  "
                  :disabled="
                    row.su === 'CS' ||
                      row.au === '' ||
                      row.au === ' ' ||
                      row.au === undefined
                  "
                  :value="
                    row.auLen !== undefined ? addTwoZeros(row.auLen) : row.auLen
                  "
                  @change.native="row.auLen = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                  class="auWid"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'auWid',
                      row.auWid
                    )
                  "
                  :disabled="
                    row.su === 'CS' ||
                      row.au === '' ||
                      row.au === ' ' ||
                      row.au === undefined
                  "
                  :value="
                    row.auWid !== undefined ? addTwoZeros(row.auWid) : row.auWid
                  "
                  @change.native="row.auWid = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                  class="auHt"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'auHt',
                      row.auHt
                    )
                  "
                  :disabled="
                    row.su === 'CS' ||
                      row.au === '' ||
                      row.au === ' ' ||
                      row.au === undefined
                  "
                  :value="
                    row.auHt !== undefined ? addTwoZeros(row.auHt) : row.auHt
                  "
                  @change.native="row.auHt = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  class="ti text-align-right"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'ti', row.ti)
                  "
                  oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 5)
                        this.value = this.value.slice(0, 5);"
                  :value="row.ti"
                  @change.native="row.ti = $event.target.value"
                ></b-input>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      class="ibm"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ibm',
                          row.ibm
                        )
                      "
                      :value="row.ibm"
                      @change.native="row.ibm = $event.target.value"
                    ></b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 5)
                          this.value = this.value.slice(0, 5);"
                  class="wrnt"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'wrnt',
                      row.wrnt
                    )
                  "
                  :value="row.wrnt"
                  @change.native="row.wrnt = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value > 3650) this.value = 3650;  this.value === '' ? '' : this.value = +this.value"
                  class="shlfLfNum"
                  v-bind:class="[
                    (row.shlfLfNum === 0 || row.shlfLfNum < row.srcRcv
                      ? 'is-danger'
                      : '',
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'shlfLfNum',
                      row.shlfLfNum
                    ))
                  ]"
                  :value="row.shlfLfNum"
                  @change.native="row.shlfLfNum = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 3)
                        this.value = this.value.slice(0, 3);"
                  class="vpa text-align-right"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'vpa', row.vpa)
                  "
                  :value="row.vpa"
                  @change.native="row.vpa = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-select
                  class="prdFam"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'prdFam',
                      row.prdFam
                    )
                  "
                  v-model="row.prdFam"
                  :value="
                    row.prdFam === undefined ? (row.prdFam = ' ') : row.prdFam
                  "
                  disabled="disabled"
                  ><option value=" "></option>
                  <option value="1">1 - Research</option>
                  <option value="2">2 - Healthcare</option>
                  <option value="3">3 - Safety</option>
                  <option value="4">4 - FSE</option>
                  <option value="5">5 - FSD</option>
                  <option value="6">6 - Third Party</option>
                </b-select>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
                          this.value = this.value.slice(0, 3);"
                  class="srcExp"
                  v-bind:class="[
                    (row.srcExp === 0 ? 'is-danger' : '',
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'srcExp',
                      row.srcExp
                    ))
                  ]"
                  :value="row.srcExp"
                  @change.native="row.srcExp = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
                          this.value = this.value.slice(0, 3);"
                  class="srcRcv"
                  v-bind:class="[
                    (row.srcRcv === 0 || row.srcRcv < row.srcExp
                      ? 'is-danger'
                      : '',
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'srcRcv',
                      row.srcRcv
                    ))
                  ]"
                  :value="row.srcRcv"
                  @change.native="row.srcRcv = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-select
                  class="exp"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'exp', row.exp)
                  "
                  v-model="row.exp"
                  :value="row.exp === undefined ? (row.exp = ' ') : row.exp"
                >
                  <option value=" "></option><option value="Y">Yes</option
                  ><option value="N">No</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <ValidationProvider
                  rules="oneOf:Y,N,NA"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      v-model="row.auth"
                      class="auth"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'auth',
                          row.auth
                        )
                      "
                      :value="
                        row.auth === undefined ? (row.auth = ' ') : row.auth
                      "
                    >
                      <option value=" "></option>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'bol'">
                <v-select
                  :filterable="false"
                  :options="bolOptions"
                  class="bol"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'bol', row.bol)
                  "
                  v-model="row.bolDesc"
                  @search="fetchTypeAhead"
                  :title="row.bolDesc"
                  @input="changeOnErroredItemsRow($event, index, row)"
                >
                  <template slot="option" slot-scope="bolOption">
                    <div class="d-center">
                      {{ bolOption.label }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="bolOption">
                    <div class="selected d-center">
                      {{ bolOption.label }}
                    </div>
                  </template>
                  <template
                    slot="no-options"
                    slot-scope="{ search, searching }"
                  >
                    <template v-if="searching">
                      Sorry, no matching options.
                    </template>
                    <span v-else class="display-none"></span>
                  </template>
                </v-select>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                  class="auList"
                  :disabled="
                    row.su === 'CS' ||
                      row.au === '' ||
                      row.au === ' ' ||
                      row.au === undefined
                  "
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'auList',
                      row.auList
                    )
                  "
                  :value="
                    row.auList !== undefined
                      ? addTwoZeros(row.auList)
                      : row.auList
                  "
                  @change.native="row.auList = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-select
                  class="unitUse"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'unituse',
                      row.unituse
                    )
                  "
                  :disabled="row.su === 'EA' || row.su === 'PR'"
                  v-model="row.unituse"
                  :value="
                    row.unituse === undefined
                      ? (row.unituse = ' ')
                      : row.unituse
                  "
                >
                  <option value=" "></option><option value="CA">Case</option>
                  <option value="EA">Each</option>
                  <option value="PK">Pack</option>
                  <option value="PR">Pair</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 6)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 6) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 6);"
                  class="pkgSzQty"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'pkgszQty',
                      row.pkgszQty
                    )
                  "
                  :value="
                    row.pkgszQty !== undefined
                      ? addTwoZeros(row.pkgszQty)
                      : row.pkgszQty
                  "
                  @change.native="row.pkgszQty = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-select
                  class="pkgSzUnt"
                  v-model="row.pkgSzUnit"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'pkgSzUnt',
                      row.pkgSzUnit
                    )
                  "
                  :value="
                    row.pkgSzUnit === undefined
                      ? (row.pkgSzUnit = ' ')
                      : row.pkgSzUnit
                  "
                >
                  <option value=" "></option
                  ><option value="IN">IN - Inches</option>
                  <option value="FT">FT - Feet</option>
                  <option value="YD">YD - Yards</option>
                  <option value="UM">UM - Micrometer</option>
                  <option value="MM">MM - Millimeters</option>
                  <option value="CM">CM - Centimeters</option>
                  <option value="MT">MT - Meters</option>
                  <option value="OZ">OZ - Ounce (Liquid)</option>
                  <option value="PT">PT - Pint</option>
                  <option value="QT">QT - Quart</option>
                  <option value="GL">GL - Gallon</option>
                  <option value="UL">UL - Microliter</option>
                  <option value="ML">ML - MilliLiter</option>
                  <option value="LT">LT - Liter</option>
                  <option value="DO">DO - Ounce (Dry)</option>
                  <option value="LB">LB - Pounds</option>
                  <option value="GT">GT - Metric Gross Ton</option>
                  <option value="UG">UG - Microgram</option>
                  <option value="MG">MG - Milligram</option>
                  <option value="GR">GR - Gram</option>
                  <option value="KG">KG - Kilogram</option>
                  <option value="PP">PP - Prep</option>
                  <option value="RN">RN - Reaction</option>
                  <option value="TS">TS - Test</option>
                  <option value="MU">MU - Milliunit</option>
                  <option value="UN">UN - Unit</option>
                  <option value="KU">KU - Kilounit</option>
                  <option value="UC">UC - Microcurie</option>
                  <option value="MC">MC - Millicurie</option>
                  <option value="CI">CI - Curie</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'cdc'">
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <v-select
                      :filterable="false"
                      :options="cdcOptions"
                      class="cdc"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'cdc',
                          row.cdc
                        )
                      "
                      v-model="row.cdc"
                      @search="fetchTypeAhead"
                      @input="changeOnErroredItemsRow($event, index, row)"
                      :title="row.cdc"
                    >
                      <template slot="option" slot-scope="cdcOption">
                        <div class="d-center">
                          {{ cdcOption.label }}
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="cdcOption"
                        title="cdcOption"
                      >
                        <div class="selected d-center">
                          {{ cdcOption.label }}
                        </div>
                      </template>
                      <template
                        slot="no-options"
                        slot-scope="{ search, searching }"
                      >
                        <template v-if="searching">
                          Sorry, no matching options.
                        </template>
                        <span v-else class="display-none"></span>
                      </template>
                    </v-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-select
                  class="instl"
                  v-model="row.instl"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'instl',
                      row.instl
                    )
                  "
                  :value="
                    row.instl === undefined ? (row.instl = ' ') : row.instl
                  "
                >
                  <option value=" "></option><option value="Y">Yes</option
                  ><option value="N">No</option>
                  <option value="NA">NA</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="addPb"
                  v-model="row.addPb"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'addPb',
                      row.addPb
                    )
                  "
                  :value="
                    row.addPb === undefined ? (row.addPb = ' ') : row.addPb
                  "
                >
                  <option value=" "></option><option value="Y">Yes</option
                  ><option value="N">No</option>
                </b-select>
              </td>
              <td>
                <b-select
                  class="hz"
                  v-model="row.hz"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'hz', row.hz)
                  "
                  :value="row.hz === undefined ? (row.hz = ' ') : row.hz"
                >
                  <option value=" "></option><option value="50">50</option>
                  <option value="60">60</option>
                  <option value="25/60">25/60</option>
                  <option value="50/60">50/60</option>
                </b-select>
              </td>
              <!-- None value should be N for MF integration -->
              <td>
                <b-select
                  class="phs"
                  v-bind:class="
                    isApiErrorField(row.psfsNewItemMfLoadErrTbs, 'phs', row.phs)
                  "
                  v-model="row.phs"
                  :value="row.phs === undefined ? (row.phs = ' ') : row.phs"
                >
                  <option value=" "></option><option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="N">None</option>
                </b-select>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{3})./g, '$1');if (this.value.split('.')[0].length > 1)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 1) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 1); "
                  class="discnt"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'discnt',
                      row.discount
                    )
                  "
                  :value="
                    row.discount !== undefined
                      ? addPercentMode(row.discount)
                      : row.discount
                  "
                  @change.native="row.discount = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  :disabled="disableBasedOnSu(row.su)"
                  oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.length > 9)
                          this.value = this.value.slice(0, 9);"
                  class="suQty"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suQty',
                      row.suQty
                    )
                  "
                  :value="
                    row.suQty !== undefined ? addTwoZeros(row.suQty) : row.suQty
                  "
                  @change.native="row.suQty = $event.target.value"
                ></b-input>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'taxonomy'">
                <v-select
                  v-if="row.user3P"
                  :filterable="false"
                  :options="taxonomyOptions"
                  :selectable="
                    taxonomyOption => taxonomyOption.deleteFlag !== 'Y'
                  "
                  class="taxonomy"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'taxonomy',
                      row.taxonomy
                    )
                  "
                  v-model="row.taxonomy"
                  @search="fetchTypeAhead"
                  @input="
                    row.taxonomy = row.taxonomy
                      ? row.taxonomy.taxoCodeDesc
                      : row.taxonomy;
                    changeOnErroredItemsRow($event, index, row);
                  "
                  :title="row.taxonomy"
                >
                  <template slot="option" slot-scope="taxonomyOption">
                    <div class="d-center">
                      {{ taxonomyOption.taxoCodeDesc }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="taxonomyOption"
                    title="taxonomyOption"
                  >
                    <div class="selected d-center">
                      {{ taxonomyOption.label }}
                    </div>
                  </template>
                  <template
                    slot="no-options"
                    slot-scope="{ search, searching }"
                  >
                    <template v-if="searching">
                      Sorry, no matching options.
                    </template>
                    <span v-else class="display-none"></span>
                  </template>
                </v-select>
                <ValidationProvider
                  v-else
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <v-select
                      :filterable="false"
                      :options="taxonomyOptions"
                      :selectable="
                        taxonomyOption => taxonomyOption.deleteFlag !== 'Y'
                      "
                      class="taxonomy"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'taxonomy',
                          row.taxonomy
                        )
                      "
                      v-model="row.taxonomy"
                      @search="fetchTypeAhead"
                      @input="
                        row.taxonomy = row.taxonomy
                          ? row.taxonomy.taxoCodeDesc
                          : row.taxonomy;
                        changeOnErroredItemsRow($event, index, row);
                      "
                      :title="row.taxonomy"
                    >
                      <template slot="option" slot-scope="taxonomyOption">
                        <div class="d-center">
                          {{ taxonomyOption.taxoCodeDesc }}
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="taxonomyOption"
                        title="taxonomyOption"
                      >
                        <div class="selected d-center">
                          {{ taxonomyOption.label }}
                        </div>
                      </template>
                      <template
                        slot="no-options"
                        slot-scope="{ search, searching }"
                      >
                        <template v-if="searching">
                          Sorry, no matching options.
                        </template>
                        <span v-else class="display-none"></span>
                      </template>
                    </v-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-input
                  type="text"
                  class="uncondFcat"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'uncondFcat',
                      row.uncondFcat
                    )
                  "
                  :value="row.uncondFcat"
                  @change.native="row.uncondFcat = $event.target.value"
                  disabled
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                  class="tradMa text-align-right"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'tradMa',
                      row.tradMa
                    )
                  "
                  :value="
                    row.tradMa !== undefined
                      ? addFourZeros(row.tradMa)
                      : row.tradMa
                  "
                  @change.native="row.tradMa = $event.target.value"
                  disabled
                ></b-input>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-datepicker
                      placeholder="Select a date..."
                      icon="calendar-today"
                      class="ncExpDt"
                      :min-date="minNcExpDt"
                      v-model="row.ncExpDt"
                      @input="changeOnErroredItemsRow($event, index, row)"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemMfLoadErrTbs,
                          'ncExpDt',
                          row.ncExpDt
                        )
                      "
                    >
                    </b-datepicker>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                  class="suListFinal text-align-right"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'suListFinal',
                      row.suListFinal
                    )
                  "
                  :value="
                    row.suListFinal !== undefined
                      ? addTwoZeros(row.suListFinal)
                      : row.suListFinal
                  "
                  @change.native="row.suListFinal = $event.target.value"
                ></b-input>
              </td>
              <td>
                <b-input
                  type="text"
                  oninput="this.value = this.value
                .replace(/[^\d.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 9)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 9) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 9);"
                  v-bind:class="
                    isApiErrorField(
                      row.psfsNewItemMfLoadErrTbs,
                      'auListFinal',
                      row.auListFinal
                    )
                  "
                  :disabled="
                    row.au === '' || row.au === ' ' || row.au === undefined
                  "
                  class="auListFinal text-align-right"
                  :value="
                    row.auListFinal !== undefined
                      ? addTwoZeros(row.auListFinal)
                      : row.auListFinal
                  "
                  @change.native="row.auListFinal = $event.target.value"
                ></b-input>
              </td>
            </ValidationObserver>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import BSelect from "buefy/src/components/select/Select";
import BInput from "buefy/src/components/input/Input";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

extend("valOfAu", {
  params: ["suVal"],
  validate: (value, { suVal }) => {
    if (
      (suVal === "PK" && value === " ") ||
      (suVal === "PK" && value === "CS")
    ) {
      return true;
    } else if (suVal !== "PK") {
      return true;
    }
  }
});

extend("isPcValid", {
  params: ["mcsVal"],
  validate: (value, { mcsVal }) => {
    if (mcsVal.charAt(0) === "A") {
      if (value.startsWith("07")) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "ErroredMainframeItemsComponent.vue",
  components: { BSelect, BInput, vSelect },
  data() {
    return {
      filterMySubmissionsId: "",
      selectAllChecked: false,
      checkboxGroup: [],
      rowIds: [],
      pageIndex: 1,
      minPageIndex: "",
      maxPageIndex: "",
      totalResults: "",
      totalPages: "",
      showPreviousButton: true,
      showNextButton: true,
      numberOfItemsPerPage: 10,
      erroredItems: "",
      lineErrors: "",
      erroredItemsFilter: "",
      isLoading: false,
      typeAheadTriggered: "",
      countryOriginOptions: [],
      pcOptions: [],
      byrCodeOptions: [],
      sbuCodeOptions: [],
      cctOptions: [],
      oldMktOptions: [],
      vnIds: [],
      bolOptions: [],
      cdcOptions: [],
      taxonomyOptions: [],
      storageCodes: [],
      mcsCodes: [],
      minNcExpDt: new Date(),
      erroredMainframeItemsColumns: [
        "Line Errors",
        "Submission Id",
        "Status Description",
        "Supplier Catalog Number",
        "Fisher Catalog Number",
        "Standard Unit",
        "Price Type",
        "Product Class",
        "Safety Data Sheet Code",
        "Product Type",
        "Ice Charge",
        "Old Marketing Code",
        "Storage Code",
        "Alternate Unit",
        "Item Description - 30 Characters",
        "Vendor Number",
        "Strategic Business Unit Code (SBU)",
        "Product Code",
        "Vendor Marketing Admin Number (VMA)",
        "Price Book Section",
        "Direct Ship Indicator",
        "Buyer Code",
        "Private Label Indicator",
        "Integrity Packaging Fee (IPF)",
        "Volts",
        "Country of Origin",
        "Label Code Primary (LCP)",
        "Marketing Code Primary (MCP)",
        "Marketing Code Secondary (MCS)",
        "Commodity Code Tertiary (CCT)",
        "Healthcare Preferred Code",
        "Research Preferred Code",
        "Safety Preferred Code",
        "Uncondensed Catalog Number",
        "Control Code 1",
        "Control Code 2",
        "Control Code 3",
        "Control Code 4",
        "Control Code 5",
        "Hazardous",
        "Supplier UOM",
        "Manufacturer Name",
        "Manufacturer Catalog Number",
        "Serial / Lot Control",
        "Keyword(1)",
        "Keyword(2)",
        "Keyword(3)",
        "Keyword(4)",
        "Keyword(5)",
        "Standard Unit Cost",
        "Standard Unit List",
        "Standard Unit Weight",
        "Standard Unit Length",
        "Standard Unit Width",
        "Standard Unit Height",
        "Manufacturer Lead-Time",
        "Conversion from Supplier to Fisher",
        "Alternate Unit Quantity",
        "Alternate Unit Weight",
        "Alternate Unit Length",
        "Alternate Unit Width",
        "Alternate Unit Height",
        "Units on a Pallet",
        "IBM Number",
        "Warranty Period",
        "Shelf Life (Days)",
        "Vendor Purchasing Admin Number (VPA)",
        "Product Family",
        "Source Expiration Days",
        "Source Receiving Days",
        "Expiration",
        "Authored",
        "Bill of Lading Code",
        "Alternate Unit List",
        "Unit of Use",
        "Package Size Quantity",
        "Package Size Unit",
        "Customer Discount Category Code (CDC)",
        "Installation",
        "Price Book",
        "HZ",
        "Phase",
        "Discount %",
        "Standart Unit Quantity",
        "Leaf Node",
        "Uncondensed Fisher Catalog Number",
        "Traditional Marketing Adjustment",
        "Pricing Expiration Date",
        "Standard Unit List Price - Final",
        "Alternate Unit List Price - Final"
      ],
      erroredMainFrameItemsData: []
    };
  },
  mounted() {
    this.getErroredMFItems();
    this.loadStorageCodes();
    this.loadMcsCodes();
  },
  watch: {
    reloadErroredItems: function(value) {
      if (value) {
        this.erroredItemsFilter = "";
        this.erroredItems = "";
        this.lineErrors = "";
        this.getErroredMFItems();
      }
    },
    selectAllChecked: function(isChecked) {
      if (isChecked) {
        this.checkboxGroup = this.rowIds;
      } else {
        this.checkboxGroup = [];
      }
      this.$emit("selectedRowIdsForErroredItems", this.checkboxGroup);
    },
    checkboxGroup: function() {
      this.$emit("selectedRowIdsForErroredItems", this.checkboxGroup);
    }
  },
  props: ["reloadErroredItems"],
  methods: {
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    addTwoZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 2)
      );
    },
    addThreeZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 3)
      );
    },
    addFourZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 4)
      );
    },
    addPercentMode(value) {
      return Math.floor(value * 100) + "%";
    },
    loadMcsCodes() {
      var scope = this;
      scope.loading = true;
      scope.$http
        .get(`${process.env.VUE_APP_API_BASE_DOMAIN}loadMCSCode`)
        .then(function(response) {
          scope.loading = false;
          scope.mcsCodes = response.data;
          scope.mcsCodes.push("3P");
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.loading = false;
          scope.$buefy.dialog.alert({
            message: `Failed to load MCS codes. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    loadStorageCodes() {
      var scope = this;
      scope.loading = true;
      scope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}regltryInfo/loadStorageCodes`
        )
        .then(function(response) {
          scope.loading = false;
          scope.storageCodes = response.data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.loading = false;
          scope.$buefy.dialog.alert({
            message: `Failed to load storage codes. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    // eslint-disable-next-line no-unused-vars
    isApiErrorField(errorFieldNames, className, value) {
      if (!window.rowCreated) {
        if (errorFieldNames && errorFieldNames.length > 0) {
          for (var i = 0; i < errorFieldNames.length; i++) {
            if (
              errorFieldNames[i].columnName.replace(/_/g, "").toLowerCase() ===
              className.toLowerCase()
            ) {
              return "is-danger";
            }
          }
        } else {
          return "";
        }
      }
    },
    changeOnErroredItemsRow(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("erroredMFItemRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("erroredMFItemRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsNewItemMfLoadErrTbs" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              //logic for ncExpDt field
              if (key === "ncExpDt" && rowDataFromResponseObj[key]) {
                var date = rowDataFromResponseObj[key].split("T")[0];
                rowDataFromResponseObj[key] = new Date(
                  date.split("-")[1] +
                    "-" +
                    date.split("-")[2] +
                    "-" +
                    date.split("-")[0]
                );
                if (
                  !(
                    rowDataFromResponseObj[key] !== rowData[key] &&
                    new Date(rowDataFromResponseObj[key]).toDateString() ===
                      new Date(rowData[key]).toDateString()
                  )
                ) {
                  this.updateErroredMFItems(index, rowData);
                  break;
                }
              } else {
                if (rowData[key] === " ") {
                  rowData[key] = "";
                }
                this.updateErroredMFItems(index, rowData);
                break;
              }
            }
          }
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    disableOnDisc(row) {
      /**if (row.disc === "Y") {
        row.oldMkt = "E8";
        row.prcType = "6";
        return true;
      } */
      return true;
    },
    erroredItemsEditAccess() {
      if (
        this.erroredMainFrameItemsData.length > 0 &&
        this.erroredMainFrameItemsData[0].itemStatus === "R"
      ) {
        return "";
      } else {
        return "viewOnly";
      }
    },
    getErroredMFItems() {
      this.checkboxGroup = [];
      this.selectAllChecked = false;
      (this.countryOriginOptions = []),
        (this.pcOptions = []),
        (this.byrCodeOptions = []),
        (this.sbuCodeOptions = []),
        (this.cctOptions = []),
        (this.oldMktOptions = []),
        (this.vnIds = []),
        (this.bolOptions = []),
        (this.cdcOptions = []),
        (this.taxonomyOptions = []);

      this.$emit("selectedRowIdsForErroredItems", []);
      var scope = this;

      scope.isLoading = true;
      scope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}retriveMFFailedItemList?submissionId=${this.filterMySubmissionsId}&pageNbr=${scope.pageIndex}&pageSize=${scope.numberOfItemsPerPage}&erroredItems=${scope.erroredItems}&lineErrors=${scope.lineErrors}`
        )
        .then(function(response) {
          response.data.startIndex !== undefined
            ? (scope.minPageIndex = response.data.startIndex)
            : (scope.minPageIndex = 0);
          response.data.endIndex !== undefined
            ? (scope.maxPageIndex = response.data.endIndex)
            : (scope.maxPageIndex = 0);
          response.data.totalCount !== undefined
            ? (scope.totalResults = response.data.totalCount)
            : (scope.totalResults = 0);
          response.data.totalPages !== undefined
            ? (scope.totalPages = response.data.totalPages)
            : (scope.totalPages = 0);
          if (scope.pageIndex <= 1) {
            scope.showPreviousButton = false;
          } else {
            scope.showPreviousButton = true;
          }
          if (scope.pageIndex >= scope.totalPages) {
            scope.showNextButton = false;
          } else {
            scope.showNextButton = true;
          }

          scope.rowIds = [];
          var mutableResponseObj = response.data.psfsNewItemMFLoadTbs;
          for (
            var i = 0, lineNumber = scope.minPageIndex;
            i < mutableResponseObj.length && lineNumber > 0;
            i++, lineNumber++
          ) {
            scope.rowIds.push(mutableResponseObj[i].genlQstnId);
            mutableResponseObj[i].lineNumber = lineNumber;
            if (mutableResponseObj[i].ncExpDt) {
              var date = mutableResponseObj[i].ncExpDt.split("T")[0];
              mutableResponseObj[i].ncExpDt = new Date(
                date.split("-")[1] +
                  "-" +
                  date.split("-")[2] +
                  "-" +
                  date.split("-")[0]
              );
            }
          }
          scope.erroredMainFrameItemsData = mutableResponseObj;
          sessionStorage.setItem(
            "erroredMFItemRows",
            JSON.stringify(response.data.psfsNewItemMFLoadTbs)
          );
          scope.isLoading = false;
          //check errorCount for Resubmit and Action buttons
          if (
            scope.erroredMainFrameItemsData.length > 0 &&
            scope.erroredMainFrameItemsData[0].itemStatus === "R" &&
            response.data.errorCount === 0
          ) {
            scope.$emit("emfActionsBtns", {
              enableDataBtns: true,
              enableResubmitBtn: true
            });
          } else if (
            scope.erroredMainFrameItemsData.length > 0 &&
            scope.erroredMainFrameItemsData[0].itemStatus === "R" &&
            response.data.errorCount > 0
          ) {
            scope.$emit("emfActionsBtns", {
              enableDataBtns: true,
              enableResubmitBtn: false
            });
          } else {
            scope.$emit("emfActionsBtns", {
              enableDataBtns: false,
              enableResubmitBtn: false
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            message: `Failed to load data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            actionText: "OK"
          });
        });
    },
    updateErroredMFItems(index, requestPayload) {
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var updatedRowData = {};

      var numericRegex = /^[0-9 ]+$/g;
      if (requestPayload.uncondCat && requestPayload.uncondCat > 11) {
        if (numericRegex.test(requestPayload.uncondCat)) {
          requestPayload.uncondCat = requestPayload.uncondCat.slice(0, 11);
        } else {
          requestPayload.uncondCat = requestPayload.uncondCat.slice(0, 13);
        }
      }

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if ((key === "mcs" && prop === "") || prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      scope.isLoading = true;
      scope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}updateItemSubmission/rowId/${requestPayload.rowId}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber = scope.erroredMainFrameItemsData[index].lineNumber;
          scope.erroredMainFrameItemsData[index] = apiRow;
          var emfRows = JSON.parse(sessionStorage.getItem("erroredMFItemRows"));
          emfRows.splice(index, 1, response.data);
          sessionStorage.setItem("erroredMFItemRows", JSON.stringify(emfRows));
          //check errorCount for Resubmit and Action buttons
          if (
            scope.erroredMainFrameItemsData.length > 0 &&
            scope.erroredMainFrameItemsData[0].itemStatus === "R" &&
            response.data.totalErrorCount === 0
          ) {
            scope.$emit("emfActionsBtns", {
              enableDataBtns: true,
              enableResubmitBtn: true
            });
          } else if (
            scope.erroredMainFrameItemsData.length > 0 &&
            scope.erroredMainFrameItemsData[0].itemStatus === "R" &&
            response.data.totalErrorCount > 0
          ) {
            scope.$emit("emfActionsBtns", {
              enableDataBtns: true,
              enableResubmitBtn: false
            });
          } else {
            scope.$emit("emfActionsBtns", {
              enableDataBtns: false,
              enableResubmitBtn: false
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${requestPayload.nbrNewItemCrKey}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".errored-items-table-body")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".errored-items-table-body")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    fetchTypeAhead(search, loading) {
      var scope = this;
      var url = "";
      if (search.length > 0) {
        switch (scope.typeAheadTriggered) {
          case "pc":
            url = "loadPcCodes";
            break;
          case "byrCode":
            url = "loadByrCodes";
            break;
          case "cct":
            url = "loadCctCodes";
            break;
          case "oldMkt":
            url = "loadOldMktCodes";
            break;
          case "sbu":
            url = "loadSbuCodes";
            break;
          case "countryOrigin":
            url = "loadCountryCodes";
            break;
          case "bol":
            url = "regulatoryAffairs/ctrlCodes";
            break;
          case "taxonomy":
            url = "loadTaxonomyCodes";
            break;
          case "cdc":
            url = "loadCdcCodes";
            break;
        }
      }

      if (scope.typeAheadTriggered === "vn") {
        if (search.length > 3) {
          url = "submissionDetail/vendorNumbers";
        }
      }

      if (url) {
        loading(true);
        scope.$http
          .get(`${process.env.VUE_APP_API_BASE_DOMAIN}${url}/${search}`)
          .then(function(response) {
            loading(false);
            switch (scope.typeAheadTriggered) {
              case "pc":
                scope.pcOptions = response.data;
                break;
              case "byrCode":
                scope.byrCodeOptions = response.data;
                break;
              case "cct":
                scope.cctOptions = response.data;
                break;
              case "oldMkt":
                scope.oldMktOptions = response.data;
                break;
              case "sbu":
                scope.sbuCodeOptions = response.data;
                break;
              case "countryOrigin":
                scope.countryOriginOptions = response.data;
                break;
              case "bol":
                scope.bolOptions = response.data;
                break;
              case "taxonomy":
                scope.taxonomyOptions = response.data;
                break;
              case "cdc":
                scope.cdcOptions = response.data;
                break;
              case "vn":
                scope.vnIds = response.data;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load matching results. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    disableBasedOnSu(suVal) {
      if (suVal === "EA" || suVal === "PR" || suVal === "DZ") {
        return true;
      } else {
        return false;
      }
    },
    validateUncondCat(e) {
      var numericRegex = /^[0-9 ]+$/g;
      var value = e.target.value;
      if (numericRegex.test(value)) {
        value = value.replace(/\s/g, "").slice(0, 11);
        // return e.target.value;
      } else {
        value = value.replace(/\s/g, "").slice(0, 13);
        // return e.target.value;
      }
      e.target.value = value;
    },
    disableAuQtyIf(suVal, auVal) {
      if (
        suVal === "CS" ||
        auVal === "DZ" ||
        auVal.trim() === "" ||
        auVal === undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    renderTitle(headerName) {
      if (headerName === "Shelf Life (Days)") {
        return "Shelf life days must be greater than the source receiving days.";
      } else if (headerName === "Source Receiving Days") {
        return "Source Receiving Days must be greater than the Source Expiration days.";
      }
    }
  }
};
</script>

<style scoped></style>
